/** The primary navigation, in the order the bar shows it. */
export const NAV_LINKS = Object.freeze([
  { label: "Analyze", href: "/" },
  { label: "Latest", href: "/feed" },
  // Beside Latest rather than at the end: both are ways into what SlantScan has
  // already read, one by article and one by publisher. activeHref's
  // longest-prefix rule lights this pill for /outlets/cnn.com too.
  { label: "Outlets", href: "/outlets" },
  { label: "Compare", href: "/compare" },
  { label: "History", href: "/history" },
  { label: "Pricing", href: "/pricing" },
]);

/**
 * Which nav pill should read as "you are here" for a given path.
 *
 * PillNav matches on an exact href, so a report or any other nested route would
 * otherwise light up nothing. Longest matching prefix wins, with "/" only ever
 * matching itself.
 */
export function activeHref(pathname, links = NAV_LINKS) {
  return (
    links
      .filter((l) => l.href !== "/" && pathname.startsWith(l.href))
      .sort((a, b) => b.href.length - a.href.length)[0]?.href
    ?? (pathname === "/" ? "/" : undefined)
  );
}
